import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/task/task-template/query/', 'task list');

tbl.add(new Xtc('title', 'Title'))
tbl.add(new Xtc('task_type.title', 'Task type'))
tbl.add(new Xtc('assigned_user', 'Assigned user').renderSlot('assigned'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

